<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content class="dialog-content">
    <p class="meta" *ngIf="data?.kuerzel || data?.buchungskonto">
        <span *ngIf="data?.kuerzel">{{ data.kuerzel }}</span>
        <span *ngIf="data?.buchungskonto"> · Konto {{ data.buchungskonto }}</span>
        <span> · ID {{ data.artikel_id }}</span>
    </p>

    <p class="hint">
        Suchwörter für die KI-Rechnungserkennung. Umlaute ok (werden intern normalisiert). Enter oder Komma zum
        Hinzufügen.
    </p>

    <mat-form-field appearance="outline" class="full">
        <mat-label>Tags</mat-label>
        <mat-chip-list #chipList aria-label="Match-Tags">
            <mat-chip *ngFor="let tag of tags" [removable]="true" (removed)="removeTag(tag)">
                {{ tag }}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input
                [formControl]="tagInputCtrl"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addFromInput($event)"
                placeholder="Neues Tag…"
            />
        </mat-chip-list>
    </mat-form-field>
</div>
<div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()" [disabled]="saving">Abbrechen</button>
    <button mat-flat-button color="accent" type="button" (click)="save()" [disabled]="saving">Speichern</button>
</div>
